export const LOGOUT_QUERY_STRING: string = '?logout=yes';
export const INVITE_QUERY_STRING: string = '/#apply_invite/open?quote=';
export const CONVERSION_INVITE_QUERY_STRING: string = '/#conversion/open?invite=';
export const CONVERSION_INVITE_STRING: string = '#conversion/open';
export const DELETE_CASE_FEATURE_FLAG = 'canDeleteCase';
export const COVERPATH_EZ_APP_ROUTER = 'coverpathEZappRouter';
export const COVERPATH_ROUTER_NOTIFICATIONS = 'routerNotifications';
export const COVERPATH_ROUTER_SHOW_NW_REPLACEMENTS = 'showNorthwesternReplacements';
export const COVERPATH_INDIVIDUAL_QUOTE = 'showIndividualOwnerQuote';
export const COVERPATH_BUSINESS_QUOTE = 'showBusinessOwnerQuote';
export const COVERPATH_JOINT_QUOTE = 'showJointOwnerQuote';
export const COVERPATH_TRUST_QUOTE = 'showTrustOwnerQuote';
export const SUPPORT_PARTNERS = 'supportPartners';

export enum UNAUTHORIZED_REASON {
  agentNotFound = 1,
  proxyNotFound,
  proxyHasNoAgents,
  cannotCommunicateWithCdm,
  oktaEmailMissing,
  brokerOktaAndDSPEmailMissing,
}

export type AgentRouterInfo = {
  valid: boolean;
  name?: string;
  email?: string;
  businessUnit?: string;
  contractCode?: string;
};

export const PolicyStatusForEsign = {
  readyForSign: 'readyForSign',
  canceledDeclinedRejected: 'canceledDeclinedRejected',
  alreadySigned: 'alreadySigned',
};
